import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Column, Row } from 'hedron';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { Wrapper } from '../../components_mobile/css_global/utils.css';
import {
  genImageAlt,
  getDefaultOptions,
  getProductTrackingData,
  track,
  transformImagesToPhotoswipe,
  updatePhotoswipeImages,
} from '../../helpers';
import ShareButtons from '../../components_mobile/components/ShareButtons';
import { addToCart } from '../../common/actions/cartActions';
import Breadcrumbs from '../components/Breadcrumbs';
import RelatedProducts from '../components/RelatedProducts';
import SizeSelector from '../components/SizeSelector';
import { SizeGuide, SizeGuideLabel } from '../../components/SizeGuide';
import VerticalSpacer from '../../components_common/VerticalSpacer';
import BigButton from '../../components_common/BigButton';
import ProductDetailsProductInfo from '../../components_common/ProductInfoCard/ProductDetailsProductInfo';
import productInfoDataSanitizer from '../../components_common/ProductInfoCard/productInfoDataSanitizer';
import ProductNotFoundCard from '../../components_common/ProductNotFoundCard/ProductNotFoundCard';
import { PhotoSwipe } from '../../components_common/customized_modules';
import ProductDetailsDescriptionGroup from '../../components_common/ProductDetailsDescriptionGroup/ProductDetailsDescriptionGroup';
import generateProductDetailsDescriptionData from '../../helpers/productDetailsDescriptionHelper';
import TrackingEvents from '../../common/models/TrackingEvents';
import { ProductMicrodata } from '../../components_common/Microdata';
import { normalizeSizeSelectorOptionsOrder, normalizeSizeValueName } from '../../helpers/sizeHelper';
import { formatModelNumber } from '../../helpers/pdpHelpers';
import EyewearWarning from '../../components/EyewearWarning';
import { shouldDisplayEyewearWarning } from '../../common/models/Category';
import withCountryCode from '../../components/RoutesHoc/RoutesHoc';
import ProductExcludedModal from '../../components/ProductExcludedModal/ProductExcludedModal';
import timerQueue, { EventType } from '../../helpers/TimerQueue';

/* eslint-disable @typescript-eslint/camelcase */
const isProductUnavailable = product => isEmpty(product) || product.product_is_active === 'N';

const mapStateToProps = ({
  api: {
    basePathAdmin,
    category_id,
    countryId,
    currencyIso,
    currencySymbol,
    fbOg,
    freeShipping,
    path,
    product,
    s3BasePath,
    trackingProductData,
    trackingSizeData,
    twitter,
  },
  countryCode,
  department,
}) => ({
  basePathAdmin,
  category_id,
  countryCode,
  countryId,
  currencyIso,
  currencySymbol,
  department,
  fbOg,
  freeShipping,
  path,
  product,
  s3BasePath,
  trackingProductData,
  trackingSizeData,
  twitter,
});

const mapDispatchToProps = dispatch => ({
  handleAddProduct: productVersionOptionId => dispatch(addToCart(productVersionOptionId)),
});

class ProductDetail extends Component {
  constructor(props) {
    super(props);
    this.handleSizeClick = this.handleSizeClick.bind(this);
    this.redirectToCart = this.redirectToCart.bind(this);
    this.state = {
      addToCartText: 'Add to Cart',
      currentImageIndex: 0,
      isPhotoSwipeOpen: false,
      photoSwipeOptions: {},
      selectedLabel: '',
      selectedRecapLabel: '',
      selectedSize: null,
      selectedThumb: 0,
      showSelectSizeBadge: false,
      sizeGuideVisible: false,
    };
  }

  componentWillMount() {
    const { product, router } = this.props;
    const { options } = product;

    if (isProductUnavailable(product)) {
      return;
    }

    if (!product.images || product.images.length === 0) {
      return;
    }

    const availableOptions = options.reduce((available, option) => {
      if (option.nr_available > 0) {
        available.push(option);
      }
      return available;
    }, []);

    // if only one size available, automatically select it
    if (availableOptions.length === 1) {
      const selectorOption = this.selectorOption(availableOptions[0], product.size_unit_system);
      this.setState({
        selectedSize: selectorOption.value,
        selectedLabel: selectorOption.label,
        selectedRecapLabel: selectorOption.recapLabel,
      });
    }
  }

  componentDidMount() {
    const { product, currencySymbol } = this.props;
    const { images, options, size_unit_system: sizeUnitSystem, isExcluded } = product;

    if (isExcluded) {
      this.trackingPdpBlockers(TrackingEvents.productUnavailable());
      return;
    }

    if (isProductUnavailable(product)) {
      this.trackingPdpBlockers(TrackingEvents.productUnavailable());
      return;
    }

    if (!images || images.length === 0) {
      this.trackingPdpBlockers(TrackingEvents.productNoImages());
      return;
    }

    const selectorOptions = options.map(option => this.selectorOption(option, sizeUnitSystem));
    const isOutOfStock = selectorOptions.every(option => option.disabled);
    track(TrackingEvents.productsDetailViewed(), getProductTrackingData(product, currencySymbol, { pdpPage: true }));

    if (isOutOfStock) {
      this.trackingPdpBlockers(TrackingEvents.productOutOfStock());
    }

    const photoSwipeImages = transformImagesToPhotoswipe(product.images, true);

    this.setState({
      photoSwipeImages,
      productData: window.ueTrackingProductDetailData,
      sizeData: window.ueTrackingSizeData,
      showImages: true,
    });
  }

  trackingPdpBlockers(eventName) {
    const { department, product } = this.props;
    const {
      category,
      product_id,
      brand,
      model,
      color,
      isExcluded,
      model_number,
      season,
      store,
      product_is_active,
    } = product;

    track(eventName, {
      categoryDepartment: {
        department: department.toLowerCase(),
      },
      product: {
        product_id,
        brand,
        model,
        category,
        color,
        is_excluded: isExcluded,
        model_number,
        season,
        store,
        product_is_active,
      },
    });
  }

  handleSizeClick(e) {
    if (this.state.selectedSize !== e.target.value) {
      this.setState({
        addToCartText: 'Add to Cart',
        selectedSize: e.target.value,
      });
    }
  }

  redirectToCart(e) {
    e.preventDefault();
    const { selectedSize } = this.state;
    const { product, currencySymbol, handleAddProduct } = this.props;
    timerQueue.addEvent({
      callback: () =>
        track(
          TrackingEvents.productAdded(),
          getProductTrackingData(product, currencySymbol, { productVersionOptionId: selectedSize }),
        ),
      type: EventType.UserEvent,
    });
    handleAddProduct(selectedSize);
  }

  selectorOption(option, size_unit_system) {
    const { nr_available, product_version_option_id: value, size: rawSize } = option;
    const size = normalizeSizeValueName(rawSize);

    return {
      disabled: nr_available < 1,
      label: `Selected Size: ${size}`,
      recapLabel: ` ${size}${size_unit_system && !size.includes(size_unit_system) ? ` (${size_unit_system})` : ''}`,
      size,
      value,
      rawSize,
    };
  }

  displayProductImage = event => {
    event.preventDefault();
    track(TrackingEvents.productImageViewed());
    const index = Number(event.currentTarget.dataset.imageIndex);
    this.setState({
      currentImageIndex: index,
    });
  };

  handlePhotoSwipeClose = instance => {
    this.setState({
      currentImageIndex: instance.getCurrentIndex(),
      isPhotoSwipeOpen: false,
    });
  };

  handlePhotoSwipeOpen = e => {
    e.preventDefault();

    // in transformImagesToPhotoswipe there is an event handler on image load, until it
    // fires and sets w & h props we shouldn't allow for opening zoom as the image will not be centered
    const shouldReturn = this.state.photoSwipeImages.filter(el => {
      return !el.w || !el.h;
    }).length;

    if (shouldReturn) {
      return;
    }

    const images = updatePhotoswipeImages(this.state.photoSwipeImages);

    this.setState({
      isPhotoSwipeOpen: true,
      photoSwipeImages: images,
      photoSwipeOptions: getDefaultOptions(this.state.currentImageIndex),
    });
  };

  renderProductUnavailable() {
    const {
      product: { category, category_path, currencyIso, freeShipping, model, rrp },
      buildUrlWithCountry,
      countryCode,
    } = this.props;

    let url = null;
    if (category_path) {
      url = buildUrlWithCountry(`/${category_path.ancestors}/${category_path.category_id}`);
    }

    const mediumImage = get(this.props, 'product.images[0].medium', null);

    return (
      <Wrapper height="70vh">
        <ProductNotFoundCard
          buttonText={category}
          buttonUrl={url}
          countryCode={countryCode}
          currencyIso={currencyIso}
          freeShipping={freeShipping}
          image={mediumImage}
          isDesktop
          model={model}
          price={rrp}
        />
      </Wrapper>
    );
  }

  renderProductDetails() {
    const {
      basePathAdmin,
      category_id,
      countryId,
      countryCode,
      currencyIso,
      currencySymbol,
      department,
      fbOg,
      freeShipping,
      path,
      product,
      product: {
        canEdit,
        brand,
        brand_url,
        category,
        category_path,
        isExcluded,
        color,
        description,
        images,
        model,
        model_number,
        navigation_path,
        options,
        related_products,
        rrp_eur_ex_tax,
        size_fit,
        size_unit_system: sizeUnitSystem,
      },
      s3BasePath,
      buildUrlWithCountry,
      twitter,
    } = this.props;
    const {
      addToCartText,
      carouselImages,
      currentImageIndex,
      isPhotoSwipeOpen,
      photoSwipeImages,
      photoSwipeOptions,
      products,
      selectedLabel,
      selectedRecapLabel,
      showSelectSizeBadge,
      selectedSize,
      sizeGuideVisible,
      showImages,
    } = this.state;

    const selectorTitleText = sizeUnitSystem ? `Size: ${sizeUnitSystem}` : 'Size';
    const selectorOptions = normalizeSizeSelectorOptionsOrder(
      options.map(option => this.selectorOption(option, sizeUnitSystem)),
      sizeUnitSystem,
    );

    const isOutOfStock = selectorOptions.every(option => option.disabled);
    const outOfStockButtonText = `Back to ${navigation_path[navigation_path.length - 1].name}`;
    const outOfStockLink = `/${navigation_path[navigation_path.length - 1].url}`;

    return (
      <div>
        <PhotoSwipe
          close={this.handlePhotoSwipeClose}
          isOpen={isPhotoSwipeOpen}
          items={photoSwipeImages}
          options={photoSwipeOptions}
        />
        {isExcluded && <ProductExcludedModal category={category} categoryPath={category_path} />}
        <Breadcrumbs department={department} navigationPath={navigation_path} product={product} />
        <VerticalSpacer height="25px" />
        <Wrapper>
          {sizeGuideVisible ? (
            <SizeGuide
              padding="0"
              currentCategoryId={category_id}
              department={department}
              s3BasePath={s3BasePath}
              closeSizeGuide={() => this.setState({ sizeGuideVisible: false })}
            />
          ) : null}
          <Row data-cy="product-detail-image">
            <Column lg={2}>
              <div style={{ width: '72px', visibility: showImages ? 'visible' : 'hidden' }}>
                <div id="product_images">
                  <div id="product_images_thumbs" ref={elem => (this.thumbs = elem)}>
                    {map(images, (curr, index) => (
                      <a
                        key={`thumb_img_${index}`}
                        href={curr.zoom}
                        id={`thumb:${index}`}
                        data-image={curr.medium}
                        data-image-index={index}
                        data-zoom-id="zoomer"
                        className={index === currentImageIndex ? 'active' : ''}
                        onClick={this.displayProductImage}
                      >
                        <img
                          src={curr.thumb}
                          alt={genImageAlt(model, brand, color)}
                          title={model}
                          data-cy="img-product-thumbnail"
                        />
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </Column>
            <Column lg={5}>
              <div style={{ width: '390px', visibility: showImages ? 'visible' : 'hidden' }}>
                <Row justifyContent="center">
                  <div className="product_images_zoom">
                    <a
                      id="zoomer"
                      href={images[currentImageIndex].zoom}
                      onClick={this.handlePhotoSwipeOpen}
                      data-options="hint: always; rightClick:true; zoomPosition: inner; cssClass: no-expand-thumbnails;"
                    >
                      <img
                        itemProp="image"
                        src={images[currentImageIndex].medium}
                        alt={genImageAlt(model, brand, color)}
                        width="390px"
                        id="currentImg"
                        data-cy="img-product-zoom"
                      />
                    </a>
                  </div>
                </Row>
              </div>
            </Column>
            <Column lg={5}>
              <div data-cy="product-detail-info-card">
                <ProductDetailsProductInfo
                  adminBaseUrl={canEdit ? basePathAdmin : null}
                  currencySymbol={currencySymbol}
                  product={productInfoDataSanitizer(product)}
                  isDesktop
                  showSale={freeShipping}
                />
                <SizeSelector
                  data-cy="product-detail-size-selector"
                  sizeUnitSystem={sizeUnitSystem}
                  isOutOfStock={isOutOfStock}
                  selectedLabel={selectedLabel}
                  selectedSize={selectedSize}
                  selectorOptions={selectorOptions}
                  selectorTitleText={selectorTitleText}
                  selectFn={(selectedLabel, selectedSize, selectedRecapLabel) =>
                    this.setState({
                      selectedLabel,
                      selectedRecapLabel,
                      selectedSize,
                      showSelectSizeBadge: false,
                    })
                  }
                  showSelectSizeBadge={showSelectSizeBadge}
                />
                <Wrapper margin="20px 0 10px 0">
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      maxWidth: '300px',
                    }}
                  >
                    You chose: {product.color} {selectedRecapLabel}{' '}
                    <SizeGuideLabel
                      department={department}
                      setSizeGuideVisible={() => {
                        this.setState({ sizeGuideVisible: true });
                      }}
                      nonspecificLabel
                    />
                  </div>
                </Wrapper>
                {isOutOfStock && (
                  <a className="out_of_stock_button" href={outOfStockLink} data-cy="anchor-product-back-link">
                    {outOfStockButtonText}
                  </a>
                )}
                {!isOutOfStock && (
                  <BigButton
                    width="300px"
                    onClick={e => {
                      if (!selectedSize) {
                        this.setState({ showSelectSizeBadge: true });
                      } else {
                        this.redirectToCart(e);
                      }
                    }}
                    data-cy="button-add-to-cart"
                    data-cy-pid={product.product_id}
                    data-cy-pvid={product.product_version_id}
                    data-cy-pvoid={selectedSize}
                  >
                    Add To Cart
                  </BigButton>
                )}

                {model_number && (
                  <Wrapper margin="20px 0 0 0">
                    <span>Model number: {formatModelNumber(model_number)}</span>
                  </Wrapper>
                )}

                {shouldDisplayEyewearWarning(category_id, countryId) ? <EyewearWarning /> : null}

                <ShareButtons
                  margin="5% 0 5% 0"
                  s3BasePath={s3BasePath}
                  img={images ? images[0].medium : null}
                  fbOg={fbOg}
                  twitter={twitter}
                  isDesktop
                />
                <ProductDetailsDescriptionGroup
                  s3BasePath={s3BasePath}
                  isDesktop
                  data={generateProductDetailsDescriptionData(
                    description,
                    size_fit,
                    currencySymbol,
                    buildUrlWithCountry,
                  )}
                />
              </div>
            </Column>
          </Row>
        </Wrapper>

        <ProductMicrodata
          countryCode={countryCode}
          currencyIso={currencyIso}
          freeShipping={freeShipping}
          image={images ? images[0].medium : null}
          isOutOfStock={isOutOfStock || isExcluded}
          price={product.rrp}
          productName={model}
        />

        <RelatedProducts
          department={department}
          brandName={brand}
          brandUrl={brand_url}
          currencySymbol={currencySymbol}
          products={related_products}
          s3BasePath={s3BasePath}
          showSale={freeShipping}
        />
      </div>
    );
  }

  render() {
    const { product } = this.props;
    return isProductUnavailable(product) || !product.images || product.images.length === 0
      ? this.renderProductUnavailable()
      : this.renderProductDetails();
  }
}

ProductDetail.propTypes = {
  basePathAdmin: PropTypes.string,
  canEdit: PropTypes.bool,
  currencySymbol: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  product: PropTypes.object.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  handleAddProduct: PropTypes.func.isRequired,
  freeShipping: PropTypes.func.isRequired,
  buildUrlWithCountry: PropTypes.func.isRequired,
};

ProductDetail = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductDetail);

export default withCountryCode(ProductDetail);

// add to cart onClick="fbAddCartPixelEvent(event, fbCartParams)"
